const _ = require('./enum');
const Types = require('./types');
const ListTypes = require('../../../listTypes/enum');
const issuerList = require('../../../issuers/list');
const schemeList = require('../../../schemes/list');

module.exports = {
  [_.AMOUNT]: {
    id: _.AMOUNT,
    label: 'Amount',
    type: Types.AMOUNT_RANGE,
  },
  [_.CARD_COUNTRY]: {
    id: _.CARD_COUNTRY,
    label: 'Card country',
    type: Types.MULTI_SELECT,
    references: 'countries',
  },
  [_.CUSTOMER_ID]: {
    id: _.CUSTOMER_ID,
    label: 'Customer ID',
    type: Types.MULTI_INPUT,
    listType: ListTypes.CUSTOMER_ID,
  },
  [_.CUSTOMER_IP_COUNTRY]: {
    id: _.CUSTOMER_IP_COUNTRY,
    label: 'Customer IP country',
    type: Types.MULTI_SELECT,
    references: 'countries',
  },
  [_.CUSTOMER_EMAIL]: {
    id: _.CUSTOMER_EMAIL,
    label: 'Customer Email',
    type: Types.MULTI_INPUT,
    listType: ListTypes.CUSTOMER_EMAIL,
  },
  [_.ISSUER]: {
    id: _.ISSUER,
    label: 'Issuer',
    type: Types.MULTI_SELECT,
    options: issuerList,
  },
  [_.PRODUCT_TYPE]: {
    id: _.PRODUCT_TYPE,
    label: 'Product type',
    type: Types.MULTI_SELECT,
    options: [
      { id: 'digital', label: 'Digital' },
      { id: 'physical', label: 'Physical' },
    ],
  },
  [_.SCHEME]: {
    id: _.SCHEME,
    label: 'Scheme',
    type: Types.MULTI_SELECT,
    options: schemeList,
  },
  [_.STORE_ID]: {
    id: _.STORE_ID,
    label: 'Store ID',
    type: Types.MULTI_INPUT,
  },
};
